import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  LOGOUT,
  EMAIL_SENT_SUCCESS,
  PASSWORD_RESET_SUCCESS,
  UPDATE_USER,
  TWO_FACTOR_AUTH,
} from "./authTypes";
import { SET_MESSAGE } from "../Message/types";

import AuthServices from "../../services/auth.services";
import { SUPER_ADMIN } from "../../../config/roles";
import { SET_GUIDE_STEPS, UPDATE_TOUR_STATE } from "../Admin/types";
import { isAndroid, isIOS, isMobile } from "react-device-detect";
import guideSteps from "../../../helpers/guideSteps";

export const register = (data) => (dispatch) => {
  return AuthServices.register(data)
    .then((res) => {
      dispatch({ type: REGISTER_SUCCESS });
      dispatch({
        type: SET_MESSAGE,
        payload: "Registeration Successfull",
      });

      return Promise.resolve();
    })
    .catch((err) => {
      dispatch({ type: REGISTER_FAIL });
      dispatch({
        type: SET_MESSAGE,
        data: err.response.data || err.response.data.data,
      });
      return Promise.reject();
    });
};

export const login = (data) => (dispatch) => {
  return AuthServices.login(data).then(
    (data) => {
      if (data?.data?.role === SUPER_ADMIN) {
        dispatch({
          type: TWO_FACTOR_AUTH,
          payload: { twoFactorAuth: true, twoFactorEmail: data?.data?.email },
        });
      } else {
        dispatch({
          type: LOGIN_SUCCESS,
          payload: { user: data },
        });
        dispatch({
          type: SET_GUIDE_STEPS,
          payload: guideSteps(data?.role),
        });
        if (data?.showTourGuid === undefined || data?.showTourGuid === true) {
          if (!isAndroid && !isIOS && !isMobile) {
            setTimeout(() => {
              dispatch({
                type: UPDATE_TOUR_STATE,
                payload: { run: true, stepIndex: 0, tourActive: true },
              });
            }, 3500);
          }
        }
      }

      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: LOGIN_FAIL,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: error.response.data.data,
      });
      return Promise.reject();
    }
  );
};
export const twoFactorAuthLogin = (data) => (dispatch) => {
  return AuthServices.twoFactorAtuh(data).then(
    (data) => {
      dispatch({
        type: LOGIN_SUCCESS,
        payload: { user: data },
      });
      dispatch({
        type: TWO_FACTOR_AUTH,
        payload: { twoFactorAuth: false, twoFactorEmail: "" },
      });
      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: LOGIN_FAIL,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: error.response.data.data,
      });
      return Promise.reject();
    }
  );
};
export const forgotPassword = (data) => (dispatch) => {
  return AuthServices.forgotPassword(data).then(
    (data) => {
      dispatch({
        type: EMAIL_SENT_SUCCESS,
        payload: {},
      });
      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: LOGIN_FAIL,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: error?.response?.data?.data?.message,
      });
      return Promise.reject();
    }
  );
};
export const resetPassword = (data) => (dispatch) => {
  return AuthServices.resetPassword(data).then(
    (data) => {
      dispatch({
        type: PASSWORD_RESET_SUCCESS,
        payload: {},
      });
      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: LOGIN_FAIL,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: error?.response?.data?.data,
      });
      return Promise.reject();
    }
  );
};
export const logout = (user) => (dispatch, getState) => {
  if (!user) {
    if (getState()?.auth?.isLoggedIn) AuthServices.logout(getState().auth.user);
  } else AuthServices.logout(user);
  dispatch({
    type: LOGOUT,
  });
  localStorage.removeItem("user");
  localStorage.removeItem("tourShown");
};

export const getUpdatedUserDate = () => (dispatch) => {
  return AuthServices.getUpdatedUserInfo().then(
    (data) => {
      dispatch({
        type: UPDATE_USER,
        payload: data.data,
      });
      return Promise.resolve();
    },
    (error) => {
      return Promise.reject();
    }
  );
};
